import { createApiRef } from '@backstage/core-plugin-api';
import { AppConfigConfiguration, AppConfigProfile } from '../types/types';

export const appConfigApiRef = createApiRef<AppConfigApi>({
  id: 'plugin.appconfig.service',
});

export interface AppConfigApi {
  getProfiles(accountId: string, region?: string): Promise<AppConfigProfile[]>;

  getConfiguration(
    accountId: string,
    applicationId: string,
    environmentId: string,
    profileId: string,
    region?: string,
  ): Promise<AppConfigConfiguration>;
}
